const locale = {
    placeholder: 'Επιλέξτε ώρα',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/el_GR.tsx